export interface ExportedRecordMetadata {
	workfileId: string;
	entryId: number;
	projectNumber: string;
	entityName: string;
}
